import React, { Component, createRef } from "react";
import moment from "moment";
import "./PaypalModal.css";
import { appointmentService } from "../../services/appointment.service";

export default class PaypalModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paypalError: "",
    };
    const paypalButtonRef = createRef();
  }

  componentDidMount() {
    this.renderPaypalButton();
  }

  renderPaypalButton = () => {
    window.paypal
      .Buttons({
        createOrder: (data, actions) => {
          return actions.order.create({
            purchase_units: [
              {
                description: "Counsellor",
                amount: {
                  currency_code: "USD",
                  value: this.props.counsellorDetails.price_usd,
                },
              },
            ],
            application_context: {
              shipping_preference: "NO_SHIPPING",
            },
          });
        },
        onApprove: async (data, actions) => {
          this.props.setIsLoading(true);
          appointmentService
            .capturePaypalOrder({ orderid: data.orderID })
            .then((resp) => {
              if (resp.ok === true) {
                this.setState({
                  paypalError: false,
                });
                this.props.setIsLoading(false);

                // Get Response from body
                resp.json().then((res) => {
                  this.props.callAppointmentApiCall(res, "", "paypal");
                });
              }

              if (resp.ok === false) {
                this.props.setIsLoading(false);
                // Get Response from body
                resp.json().then((res) => {
                  this.setState({
                    paypalError: res.details[0].description,
                  });
                  this.props.callAppointmentApiCall(res, "", "paypal");
                });
                // return actions.restart();
              }
            });
        },
        onError: (err) => {
          console.error(err);
        },
        onCancel: function (data) {
          console.log("your Payment has been canceled");
          // Show a cancel page, or return to cart
        },
      })
      .render(this.paypalButtonRef);
  };

  render() {
    return (
      <div className="paypal-modal-box" onClick={this.props.showPaypalModal}>
        <div
          className={`paypal-modal-inner ${
            this.state.paypalError && "paypal-error-border"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <h2>Pay For Your Appointment</h2>
          <h3>Fee : ${this.props.counsellorDetails.price_usd} </h3>
          <div className="text-center mt-3">
            Your chosen time is{" "}
            {moment(this.props.selected_date_time).format("LLLL")}
          </div>
          <br />

          <div ref={(v) => (this.paypalButtonRef = v)}></div>
          <div className="text-center mt-3">
            Note: Incorrect Credit Card or related details would cause an error
            here.
          </div>
          <br />
          {this.state.paypalError ? (
            <div className="paypal-error text-center mt-3">
              <p>Sorry, your payment was not successful.</p>
              <p>{this.state.paypalError}</p>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PaypalModal/PaypalModal.js